/**
 * ============================================================================
 * ProgramCard2 (MVC feature barrel)
 * ============================================================================
 * Purpose: Public entry for homepage / programs list cards.
 * Wire: ProgramListing → default export.
 * ============================================================================
 */

"use client";

import { memo } from "react";
import { useProgramCard2Controller } from "./controller/useProgramCard2Controller";
import ProgramCard2View from "./view/ProgramCard2View";
import type { ProgramCard2Props } from "./model/program-card2.types";

export type {
  ProgramCard2Props,
  ProgramCard2ViewModel,
  CollabLogoKey,
} from "./model/program-card2.types";
export { mapProgramCard2Display } from "./mapper/program-card2.mapper";

function ProgramCard2(props: ProgramCard2Props) {
  const viewModel = useProgramCard2Controller(props);
  return <ProgramCard2View {...viewModel} />;
}

export default memo(ProgramCard2);
